import { WorkOrderAssignmentStatus } from "@/gql/graphql";
import { BadgeColor } from "@/components/catalyst/badge";

export const assignmentStatusColorMap: Record<
  WorkOrderAssignmentStatus,
  BadgeColor
> = {
  [WorkOrderAssignmentStatus.Assigned]: "zinc",
  [WorkOrderAssignmentStatus.OnRoad]: "yellow",
  [WorkOrderAssignmentStatus.Delivered]: "blue",
  [WorkOrderAssignmentStatus.ReceiptsUploaded]: "purple",
  [WorkOrderAssignmentStatus.ReceiptsApproved]: "indigo",
  [WorkOrderAssignmentStatus.Completed]: "green",
};
